import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';


@Injectable({
  providedIn: 'root',
})
export class FormGuardGuard {
  private authServ = inject(AuthenticationService);
  private router = inject(Router);

  private readonly _23 = ['/portal-calculation', '/portal-changes', '/portal-clients'];
  private readonly _123 = ['/user-info', '/portal-policies', '/frame-policy'];
  private readonly permissioned = Object.freeze({
    3: [...this._123, ...this._23, '/portal-chat', '/konto', '/portal-home'],
    2: [...this._123, ...this._23, '/dashboard'],
    1: [...this._123, '/smlouvy', '/qr', '/poslat', '/paid', '/online', '/workflow', '/policy-change', '/approve', '/konto'],
    0: []
  });

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (nextState.url === '/login') return true;
    return component[`mayILeaveYou`]();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = '/' + state.url.substring(1).replace(/[/?;].*$/, '');
    const mayI = this.permissioned[this.authServ.currentUserValue.userType].includes(url);
    if (!mayI) this.router.navigate(['/notfound']);
    return mayI;
  }
}
